export function Bigloader() {
  return (
    <center className="mt-5">
      <div className="spinner-border text-primary" />
    </center>
  );
}
